import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { get } from 'lodash';

import type { State } from '../../../reducers';
import { loadOnboardingTip, saveOnboardingTip } from '../onboardingToLocalStorage';
import { Tips } from '../types';
import type { OnboardingState } from './types';

const initialState: OnboardingState = Object.values(Tips).reduce(
    (acc, tip) => ({
        ...acc,
        [tip]: loadOnboardingTip(tip),
    }),
    {}
);

const name = 'onboarding';

const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers: {
        setShowOnboardingTip: (state: OnboardingState, action: PayloadAction<{ type: Tips; value: boolean }>): void => {
            state[action.payload.type] = action.payload.value;
            saveOnboardingTip(action.payload.type, action.payload.value);
        },
    },
});

export const onboardingActions = actions;
export const onboardingReducer = reducer;

const getBase = (state: State): OnboardingState | undefined => get(state, name);

export const getShowOnboardingTip = (state: State, tip: Tips): boolean => get(getBase(state), tip, false);
